import styled from "styled-components";
import { Dialog } from "@mui/material";

export const MiniModalBox = styled(Dialog)`
  & .MuiDialog-paper {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 30vw;
    height: fit-content;
    max-height: 85vh;
    background-color: ${({ theme }) => {
      return theme.colors.background;
    }};
    border-radius: 5px;
  }
  & .MuiButtonBase-root{
    margin:5px 0px;
  }
  & .MuiDialogContent-root {
    padding: 30px;
  },
  & .MuiDialogActions-root {
    display:flex;
    justify-content: center;
    //text-align:center;
    padding: 10px 0px;
  },
`;

export const TitleModal = styled.div`
  text-align: left;
  font: normal normal 600 18px/22px Open Sans;
  color: ${({ theme }) => {
    return theme.colors.green;
  }};
  opacity: 1;
`;
